import { createFileRoute } from "@tanstack/react-router"

import { CockpitPanel } from "@/pages/CockpitPanel"

export const Route = createFileRoute("/portfolio/cockpit")({
  component: CockpitPanel,
})
